<template>
  <div class="container min-vh-100 d-md-flex align-items-center">
    <div class="d-block flex-grow-1 py-4 py-md-5">
      <router-view/>

      <div class="mt-4 mb-3 text-center">
        <span class="bg-black-transparent text-white p-1 rounded">⚡️ by <a href="https://www.routelogic.nl/" class="text-white">RouteLogic</a></span>
      </div>
    </div>
  </div>
</template>

<script>
import './sass/app.scss';

export default {
  name: 'app',
};
</script>
